import { gql } from "@apollo/client";

export const getUsersQuery = gql`
    query GetUsers($pagination: PaginationInfo!, $filter: GetListFilter!, $marketplaceId: Float) {
        getUsers(pagination: $pagination, filter: $filter, marketplaceId: $marketplaceId){
            users{
            id,
            email,
            disabled,
            name,
            permissions
            },
            totalCount
        },
    }
`;

export const getUserQuery = gql`
    query GetUser($userId: Float!) {
        getUser(userId: $userId){
            id,
            email,
            disabled,
            name,
            permissions
        },
    }
`;